export enum BarcodeType {
  Upc = 1,
  Qr = 2,
  UpcAndQr = 3,
}
